if (!customElements.get('stock-label')) {
  customElements.define('stock-label', class StockLabel extends HTMLElement {
    constructor() {
      super();
      this.productForm = this.closest('vbb-product-form-reactive');
      this.productFormId = this.productForm.id;
      this.handleVariantChange = this.handleVariantChange.bind(this);
      this.productForm.addEventListener('variant:changed', this.handleVariantChange);
      this.lowStockText = this.dataset.lowStock || window.variantStrings.lowStock;
      this.outOfStockText = this.dataset.outOfStock || window.variantStrings.soldOut;
      console.log(this)
      console.log(this.lowStockText, this.outOfStockText);
    }

    connectedCallback() {
      console.log('stock-lab connected');
    }

    handleVariantChange(event){
      const variant = this.variantDetails.find(v => v.variantId === event.detail.variantId);
      const lowStock = variant?.lowStock || false;
      const inStock = variant?.inStock || false;
      this.classList.remove('hidden');

      if(lowStock){
        this.innerText = this.lowStockText;
      } else if(inStock){
        this.innerText = '';
        this.classList.add('hidden');
      } else {
        this.innerText = this.outOfStockText;
      }
    }
    get variantDetails() {
      const variantData = this.productForm.querySelector(`#variant-details-${this.productFormId}`)?.textContent;
      if (!variantData) {
        console.warn('No variant data found');
        return [];
      }

      return JSON.parse(variantData);
    }
  });
}
